import { useHotkeys } from 'react-hotkeys-hook';

import { AppCapability, isCapable } from '@/utils/capabilities';
import { copySelection } from '@/utils/clipboard';

export function useRegisterCopyNonEditableSelectionHotkey() {
  useHotkeys(
    'mod+c',
    (e) => {
      if (!isCapable(AppCapability.HotKeys)) return;
      e.preventDefault();
      copySelection();
    },
    {
      enableOnContentEditable: false,
      enableOnFormTags: false,
    }
  );
}
